import { Box, IconButton, Link } from '@mui/material'
import CopyIcon from '@mui/icons-material/ContentCopy'

import { LinkIcon } from 'src/assets/icons'
import { useStyles } from '../styles'
import { useCopy } from 'src/hooks'
import { formatFileSize } from 'src/common/utils'

interface IProps {
  link: string | null
  title: string
  dimensions: string | null
  size?: number | null
}

export const LinkItem = ({ link, title, dimensions, size }: IProps) => {
  const classes = useStyles()
  const copy = useCopy(link)

  return (
    <li className={classes.linkWrapper}>
      <span className={classes.linkTitle}>{title}</span>
      {link ? (
        <>
          {/* <span className={classes.linkText}>{link}</span> */}
          <IconButton size="small" component={Link} href={link} target="_blank">
            <LinkIcon className={classes.linkIcon} />
          </IconButton>
          <IconButton size="small" onClick={copy}>
            <CopyIcon className={classes.linkIcon} />
          </IconButton>
          <Box sx={{ textWrap: 'nowrap' }}>
            {(size || dimensions) && '( '}
            {size && <span style={{ textWrap: 'nowrap' }}>{formatFileSize(size)}</span>}
            {size && dimensions && ' | '}
            {dimensions && <span>{dimensions}</span>}
            {(size || dimensions) && ' )'}
          </Box>
        </>
      ) : (
        '-'
      )}
    </li>
  )
}
